export default __webpack_public_path__ + "static/media/property_414.82a50bc0.png";